<template>
  <div class="pager-box">
    <el-pagination
      @current-change="handleCurrentChange"
      layout="prev, pager, next"
      :page-size="pagesize"
      :total="lenghtnum">
    </el-pagination>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        currentPage: 1, //初始页
        userList: [],
      }
    },
    props: ['lenghtnum', "pagesize"],
    methods: {
      handleCurrentChange: function (currentPage) {
        this.$emit('currentPage', currentPage)
        this.currentPage = currentPage;
      },
    }
  }
</script>
<style lang="scss" scoped>
  .pager-box {
    text-align: center;
    width: 100%;
    margin: 20px auto;
  }

  .el-pager li, .btn-next, .btn-prev {
    padding: 0 4px;
    font-size: 13px;
    min-width: 35px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center;
    line-height: 35px;
    height: 35px;
    margin: 0 5px;
    border: 1px solid #b6b6b6;
    border-radius: 3px;
    color: #b6b6b6;

    &:hover {
      border: 1px solid $mainColor !important;
      color: $mainColor;
    }

    &.active {
      background: $mainColor;
      border: 1px solid $mainColor;
      color: #fff;

      & + li {
        border-left: 1px solid #b6b6b6;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/pagescom.vue